"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
exports.displayName = 'Textarea';
var Textarea = /** @class */ (function (_super) {
    __extends(Textarea, _super);
    function Textarea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Textarea.prototype.render = function () {
        var _a = this.props, className = _a.className, hasError = _a.hasError, isScrollable = _a.isScrollable, isResizable = _a.isResizable, minHeight = _a.minHeight, maxHeight = _a.maxHeight, resizeDirection = _a.resizeDirection, textareaRef = _a.textareaRef, errorClassname = _a.errorClassname, errorComponent = _a.errorComponent, tag = _a.tag, rest = __rest(_a, ["className", "hasError", "isScrollable", "isResizable", "minHeight", "maxHeight", "resizeDirection", "textareaRef", "errorClassname", "errorComponent", "tag"]);
        var conditionClasses = {
            'p-bc-f-blue50': !hasError,
            'is-disabled': this.props.disabled,
            'is-scrollable': isScrollable,
            'resize-none': !isResizable,
            'resize-x': isResizable && resizeDirection === 'x',
            'resize-y': isResizable && resizeDirection === 'y'
        };
        conditionClasses[errorClassname || 'p-b-error p-bc-error50'] = hasError;
        var classNames = classnames('p-textbox-textarea', 'p-bc-grey40', 'p-bg-hv-white', conditionClasses, className);
        var styles = {
            minHeight: minHeight,
            maxHeight: maxHeight
        };
        return React.createElement("textarea", __assign({ "data-tag": tag, style: styles, className: classNames, ref: textareaRef }, rest));
    };
    Textarea.displayName = exports.displayName;
    Textarea.defaultProps = {
        isResizable: true,
        minHeight: 100,
        resizeDirection: 'xy',
        errorClassname: '',
        errorComponent: null
    };
    return Textarea;
}(React.PureComponent));
exports.Textarea = Textarea;
exports.default = Textarea;
//# sourceMappingURL=Textarea.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/components/Textarea.js
// module id = 329
// module chunks = 0